var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-full centered",class:_vm.$style.centered},[_c('h1',{class:_vm.$style.headingLarge},[_vm._v("Not Found")]),_vm._v(" "),_c('p',{class:_vm.$style.textLarge},[_vm._v("\n        Opps...\n        "),_c('router-link',{attrs:{"to":{name: 'home'}}},[_vm._v("\n            go to home page\n        ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcedf27c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageNotFound.vue
// module id = gKTN
// module chunks = 1